import { z } from 'zod';

import {
  basicBarChartSchema,
  basicLineChartSchema,
  bumpChartSchema,
  dotChartSchema,
  doughnutChartSchema,
  heatmapChartSchema,
  sankeyChartSchema,
  treeMapChartSchema,
  waterfallChartSchema,
} from './apache-charts';
import { tablePayloadSchema } from './table';

export * from './apache-charts';
export * from './table';

// TODO: remove ApacheChartSchema when we have a proper schema for all Apache charts
const apacheChartSchema = z.any();

export const researchVisualizationDataSchema = z.union([
  tablePayloadSchema,
  basicLineChartSchema,
  basicBarChartSchema,
  doughnutChartSchema,
  dotChartSchema,
  bumpChartSchema,
  sankeyChartSchema,
  treeMapChartSchema,
  waterfallChartSchema,
  heatmapChartSchema,
  apacheChartSchema,
]);

export type ResearchVisualizationData = z.infer<
  typeof researchVisualizationDataSchema
>;
